import { Container, Row, Col, Card, Table } from 'react-bootstrap'
import Image from 'react-bootstrap/Image';
import { Form } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import './App.css';
import axios from 'axios';
import ShowData from './ShowData';
import ShowDetail from './ShowDetail';
import Header from './components/Header';
import Footer from './components/Footer';
import { Facebook, Globe } from 'react-bootstrap-icons'

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

// *************

// function App() {
//   const [query, setQuery] = useState("")
//   const [data, setData] = useState([])

//   useEffect(() => {
//     const config = {
//       headers: {
//         "TOKEN": "UBWmZBBYYvM6l/vcSSyGYCmS2sirXnRBH0F2vvUFK2ST5NGDu00/v+dsErbOD4m5pgRjkLAd5ZvnWOQImEPlKQ=="
//       }
//     }
//     const url = `https://imagesopac.sru.ac.th/v1/api/GetPatronBorrow/${query}`

//     const fetchData = async () => {
//       const res = await axios
//         .get(url, config)
//       setData(res.data)
//       console.log(res)
//     }
//     if (query.length > 0) fetchData();
//   }, [query]);

//   return (
//     <div className='App'>
//       <Header />
//       <header className='App-header'>
//         <Container fluid="sm-5">
//           <Row>
//             <Col>
//               <Form>
//                 <Form.Group>
//                   <Col className='p-2'>
//                     <Form.Label>ตรวจสอบการยืมทรัพยากร</Form.Label>
//                   </Col>
//                   <Col className='p-2'>
//                     <Image src="https://cdn-icons-png.flaticon.com/512/2403/2403797.png" rounded width={220} />
//                   </Col>
//                   <Form.Control
//                     className='search'
//                     placeholder='กรอกรหัสสมาชิก/รหัสนักศึกษา/รหัสบัตรประชาชน...!'
//                     onChange={(e) => setQuery(e.target.value)}
//                   />
//                   {
//                     data.length === 0 ? (
//                       <Col>
//                         <Form.Text className='text-light'>
//                           Find not found
//                         </Form.Text>
//                       </Col>
//                     ) : (
//                       <ShowData data={data} />
//                     )}
//                   <Form.Text className='text-muted'>
//                     สำหรับใช้ตรวจสอบข้อมูลเบื้องต้นหากพบข้อสงสัย, ติดต่อ โทร 077-913-336 ต่อ 5801!
//                   </Form.Text>
//                   <Col>
//                     <Form.Text className='text-muted'>
//                       <a href='https://www.facebook.com/100219848073566' target='blank'><Facebook /></a>{' '}
//                       <a href='https://library.sru.ac.th' target='blank'><Globe /></a>
//                     </Form.Text>
//                   </Col>
//                 </Form.Group>
//               </Form>
//             </Col>
//           </Row>
//         </Container>
//       </header>
//       <Footer />
//     </div>

//     // <div>
//     // <Header />
//     // <Row className="justify-content-md-center">
//     //   <Col xs={12} sm={2} md={2}>
//     //     <Image src="https://cdn-icons-png.flaticon.com/512/2403/2403797.png" rounded width={250}/>
//     //   </Col>
//     // </Row>
//     //   <Container fluid="lg">
//     //     <Row>
//     //       <Col>
//     //         <Form.Control
//     //           className="search"
//     //           placeholder ='กรอกรหัสสมาชิก/รหัสนักศึกษา/รหัสบัตรประชาชน...!'
//     //           onChange={(e) => setQuery(e.target.value)}
//     //         />
//     //           {data.length === 0 ? (
//     //             <Row className="justify-content-md-center">
//     //               Find not found
//     //             </Row>
//     //           ) : (
//     //             <ShowData data={data} />
//     //           )}
//     //           {/* {<Table data={data} />} */}
//     //       </Col>
//     //     </Row>
//     //   </Container>
//     // </div>
//   )
// }

function App() {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [resName, setResName] = useState([]);
  const [resFine, setResFine] = useState([]);

  useEffect(() => {
    const config = {
      headers: {
        "TOKEN": "UBWmZBBYYvM6l/vcSSyGYCmS2sirXnRBH0F2vvUFK2ST5NGDu00/v+dsErbOD4m5pgRjkLAd5ZvnWOQImEPlKQ=="
      }
    }
    const url = `https://imagesopac.sru.ac.th/v1/api/GetPatronBorrow/${query}`

    const fetchResults = async () => {
      if (query.trim() !== '') {
        try {
          const response = await axios.get(url, config);
          setResults(response.data);
          // console.log(response);
        } catch (error) {
          console.error('Error fetching results:', error);
        }
      } else {
        setResults([]);
      }
    };

    const debounceTimer = setTimeout(fetchResults, 300);
    return () => clearTimeout(debounceTimer);
  }, [query]);


  useEffect(() => {
    const config = {
      headers: {
        "TOKEN": "UBWmZBBYYvM6l/vcSSyGYCmS2sirXnRBH0F2vvUFK2ST5NGDu00/v+dsErbOD4m5pgRjkLAd5ZvnWOQImEPlKQ=="
      }
    }
    const url = `https://imagesopac.sru.ac.th/v1/api/GetPatronRFine/${query}`

    const fetchResults = async () => {
      if (query.trim() !== '') {
        try {
          const response = await axios.get(url, config)
          setResFine(response.data)
          // console.log(response)
        } catch (error) {
          console.error('Error fetching results:', error)
        }
      } else {
        setResFine([]);
      }
    }
    const debounceTimer = setTimeout(fetchResults, 300);
    return () => clearTimeout(debounceTimer);
  }, [query]);


  useEffect(() => {
    const config = {
      headers: {
        "TOKEN": "UBWmZBBYYvM6l/vcSSyGYCmS2sirXnRBH0F2vvUFK2ST5NGDu00/v+dsErbOD4m5pgRjkLAd5ZvnWOQImEPlKQ=="
      }
    }
    const urlName = `https://imagesopac.sru.ac.th/v1/api/GetPatronDetail/${query}`

    const fetchResults = async () => {
      if (query.trim() !== '') {
        try {
          const response = await axios.get(urlName, config);
          setResName(response.data);
          // console.log(response);
        } catch (error) {
          console.error('Error fetching results:', error);
        }
      } else {
        setResName([]);
      }
    };

    const debounceTimer = setTimeout(fetchResults, 300);
    return () => clearTimeout(debounceTimer);
  }, [query]);



  return (
    <div className='App'>
      <Header />
      <header className='App-header'>
        <Container fluid="sm-5">
          <Row>
            <Col>
              <Form>
                <Form.Group>
                  <Col className='p-2'>
                    <Form.Label>ตรวจสอบการยืมทรัพยากร</Form.Label>
                  </Col>
                  <Col className='p-2'>
                    <Image src="https://cdn-icons-png.flaticon.com/512/2403/2403797.png" rounded width={220} />
                  </Col>
                  <Form.Control
                    className='search'
                    placeholder='กรอกรหัสสมาชิก/รหัสนักศึกษา/รหัสบัตรประชาชน...!'
                    onChange={(e) => setQuery(e.target.value)}
                  />
                  {/* <ul>
                      {resName.map((item, index) => (
                        <li key={index}>{item.FNAMETHAI} {item.LNAMETHAI}</li>
                      ))}
                    </ul> */}

                  {/* <ul>
                      {resFine.map((item, index) => (
                        <li key={index}>{item.TOTALMONEY}</li>
                      ))}
                    </ul> */}

                  {/* {
                    resName.length === 0 ? (
                      <Col>
                        <Form.Text className='text-light'>

                        </Form.Text>
                      </Col>
                    ) : (
                      <ShowData data={resName} />
                    )} */}

                  {
                    resName.length === 0 ? (<Col></Col>) : (<ShowDetail resName={resName} />)
                  }

                  {
                    results.length === 0 ? (
                      <Col>
                        <Form.Text className='text-light'>

                        </Form.Text>
                      </Col>
                    ) : (
                      <ShowData
                        data={results}
                      />
                    )}

                  {
                    resFine.length === 0 ? (
                      <Col>
                        <Form.Text className='text-light'>

                        </Form.Text>
                      </Col>
                    ) : (
                      <ShowData data={resFine} />
                    )}

                  <Form.Text className='text-muted'>
                    สำหรับใช้ตรวจสอบข้อมูลเบื้องต้นหากพบข้อสงสัย, ติดต่อ โทร 077-913-336 ต่อ 5801!
                  </Form.Text>

                  <Col>
                    <Form.Text className='text-muted'>
                      <a href='https://www.facebook.com/100219848073566' target='blank'><Facebook /></a>{' '}
                      <a href='https://library.sru.ac.th' target='blank'><Globe /></a>
                    </Form.Text>
                  </Col>
                </Form.Group>
              </Form>
            </Col>
          </Row>
        </Container>
      </header>
      <Footer />
    </div>
  )
}

export default App;
